import {RouteConfig} from 'vue-router'
import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'
import pollsListPage from '@/pages/polls/list.vue'
import createPollPage from '@/pages/polls/createPoll.vue'
import pollsReadyList from '@/components/polls/list/ready.vue'
import pollsProgressList from '@/components/polls/list/progress.vue'
import pollsCompletedList from '@/components/polls/list/completed.vue'
import pollsCanceledList from '@/components/polls/list/canceled.vue'
import pollPage from '@/pages/polls/pollPage.vue'
import pollPageInfo from '@/components/polls/page/tabs/info.vue'
import pollPageRcpts from '@/components/polls/page/tabs/rcpts.vue'
import pollPageResult from '@/components/polls/page/tabs/result.vue'
import {MAILING_STATUS_COMPLETED, MAILING_STATUS_PROGRESS, MAILING_STATUS_READY, MAILING_STATUS_CANCELED} from '@/constants'

// @ts-ignore
import messages from '@/lang/index';

const polls: RouteConfig = {
  path: '/polls',
  name: 'polls',
  meta: {
    pageName: messages.polls.polls
  },
  component: DashboardLayout,
  redirect: '/polls/list',
  children: [
    {
      path: 'list',
      name: 'pollsList',
      meta: {
        pageName: messages.polls.polls_list
      },
      component: pollsListPage,
      redirect: {name: 'pollsReadyList'},
      children: [
        {
          path: 'ready',
          name: 'pollsReadyList',
          meta: {
            pageName: messages.common.tabs.ready
          },
          component: pollsReadyList,
          props: { status: MAILING_STATUS_READY },
          children: [
            {
              path: 'page/:page',
              name: 'pollsReadyListPage',
              meta: {
                pageName: messages.common.tabs.ready
              },
              component: pollsReadyList,
              props: { status: MAILING_STATUS_READY },
            }
          ]
        },
        {
          path: 'inProgress',
          name: 'pollsInProgressList',
          meta: {
            pageName: messages.common.tabs.in_progress
          },
          component: pollsProgressList,
          props: { status: MAILING_STATUS_PROGRESS },
          children: [
            {
              path: 'page/:page',
              name: 'pollsInProgressListPage',
              meta: {
                pageName: messages.common.tabs.in_progress
              },
              component: pollsProgressList,
              props: { status: MAILING_STATUS_PROGRESS },
            }
          ]
        },
        {
          path: 'completed',
          name: 'pollsComplitedList',
          meta: {
            pageName: messages.common.tabs.sended
          },
          component: pollsCompletedList,
          props: { status: MAILING_STATUS_COMPLETED },
          children: [
            {
              path: 'page/:page',
              name: 'pollsComplitedListPage',
              meta: {
                pageName: messages.common.tabs.sended
              },
              component: pollsCompletedList,
              props: { status: MAILING_STATUS_COMPLETED },
            }
          ]
        },
        {
          path: 'canceled',
          name: 'pollsCanceledList',
          meta: {
            pageName: messages.common.tabs.canceled1
          },
          component: pollsCanceledList,
          props: { status: MAILING_STATUS_CANCELED },
          children: [
            {
              path: 'page/:page',
              name: 'pollsCanceledListPage',
              meta: {
                pageName: messages.common.tabs.canceled1
              },
              component: pollsCanceledList,
              props: { status: MAILING_STATUS_CANCELED },
            }
          ]
        }
      ]
    },
    {
      path: 'create',
      name: 'pollsCreate',
      meta: {
        pageName: messages.polls.creating_poll
      },
      component: createPollPage,
      children: [
        {
          path: 'page/:page',
          name: 'pollsCreatePage',
          meta: {
            pageName: messages.polls.creating_poll_page
          },
          component: createPollPage
        }
      ]
    },
    {
      path: ':id',
      name: 'pollsPage',
      meta: {
        pageName: messages.polls.poll
      },
      component: pollPage,
      props: true,
      redirect: {name: 'pollPageInfo'},
      children: [
        {
          path: 'info',
          name: 'pollPageInfo',
          meta: {
            pageName: messages.polls.poll
          },
          component: pollPageInfo,
          props: true
        },
        {
          path: 'rcpts',
          name: 'pollPageRcpts',
          meta: {
            pageName: messages.polls.recepients
          },
          component: pollPageRcpts,
          props: true,
          children: [
            {
              path: 'page/:page',
              name: 'pollPageRcptsPage',
              meta: {
                pageName: messages.polls.recepients_page
              },
              component: pollPageRcpts,
              props: true
            }
          ]
        },
        {
          path: 'result',
          name: 'pollPageResult',
          meta: {
            pageName: messages.polls.results
          },
          component: pollPageResult,
          props: true
        }
      ]
    }
  ]
}
export default polls